import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DumpInstitutionComponent } from './dump-institution.component';
import { MatFormFieldModule, MatRadioModule, MatButtonModule, MatTableModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { SaveStateData } from 'dbweb-core';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [DumpInstitutionComponent],
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatButtonModule,
		MatTableModule,
		MatRadioModule,
		FormsModule,
		RouterModule.forChild([{ path: '**', data: SaveStateData, component: DumpInstitutionComponent }])
	]
})
export class DumpInstitutionModule {}
